import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { NAV_LINKS } from '../data/nav'

interface SiteHeaderProps {
  logoSrc: string
  getAppHref: string
}

const SiteHeader: React.FC<SiteHeaderProps> = ({ logoSrc, getAppHref }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    if (!isMenuOpen) return

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsMenuOpen(false)
    }
    const handleResize = () => {
      if (window.matchMedia('(min-width: 1051px)').matches) setIsMenuOpen(false)
    }

    document.addEventListener('keydown', handleKeyDown)
    window.addEventListener('resize', handleResize)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('resize', handleResize)
    }
  }, [isMenuOpen])

  return (
    <>
      <div className="v2-header-bar">
        <nav className="v2-navpill">
          <a aria-label="Ivy home" href="#top" className="v2-navpill__brand">
            <img alt="Ivy" className="v2-logo" src={logoSrc} width={121} height={40} />
          </a>

          <div className="v2-navpill__desktop">
            <div className="v2-navpill__links">
              {NAV_LINKS.map(link => (
                <a key={link.href} href={link.href}>
                  {link.label}
                </a>
              ))}
            </div>
            <div className="v2-navpill__actions">
              <Link to="/login" className="v2-navpill__login">
                Log in
              </Link>
              <a href={getAppHref} className="v2-btn v2-btn--primary v2-btn--sm">
                Get the app
              </a>
            </div>
          </div>

          <div className="v2-navpill__mobile">
            <button
              type="button"
              aria-controls="v2-mobile-menu"
              aria-expanded={isMenuOpen}
              className="v2-menu-toggle"
              onClick={() => setIsMenuOpen(open => !open)}
            >
              {isMenuOpen ? 'Close' : 'Menu'}
            </button>
          </div>
        </nav>
      </div>

      <div aria-label="Mobile navigation" className="v2-mobile-menu-wrap" hidden={!isMenuOpen} id="v2-mobile-menu" role="navigation">
        <div className="v2-mobile-menu" onClick={event => (event.target as HTMLElement).closest('a') && setIsMenuOpen(false)}>
          {NAV_LINKS.map(link => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
          <a href={getAppHref} className="v2-mobile-menu__cta">
            Get the app
          </a>
        </div>
      </div>
    </>
  )
}

export default SiteHeader
